// extracted by mini-css-extract-plugin
export var box = "_82-1";
export var checked = "_82-2";
export var descriptionSpacer = "_82-9";
export var disabled = "_82-3";
export var icon = "_82-6";
export var input = "_82-0";
export var labelSpacer = "_82-8";
export var medium = "_82-5";
export var small = "_82-4";
export var text = "_82-7";